import type { Metric } from 'web-vitals';

/**
 * Starts web-vitals reporting. Metrics are optional: if the web-vitals chunk cannot load (a PWA left open
 * across a deploy asks for a chunk filename the new deploy no longer serves, OFFICEHUB-SALES-A), that page
 * view simply reports no metrics. The failure is swallowed here, never left as an unhandled rejection.
 * Returns the load promise so callers and tests can await it; it always resolves.
 */
const reportWebVitals = (onPerfEntry?: (metric: Metric) => void): Promise<void> | undefined => {
  if (typeof onPerfEntry === 'function') {
    return import('web-vitals')
      .then(({ onCLS, onINP, onFCP, onLCP, onTTFB }) => {
        onCLS(onPerfEntry);
        onINP(onPerfEntry); // INP replaced FID in v3+
        onFCP(onPerfEntry);
        onLCP(onPerfEntry);
        onTTFB(onPerfEntry);
      })
      .catch(() => undefined);
  }
  return undefined;
};

export default reportWebVitals;
